// extracted by mini-css-extract-plugin
module.exports = {"terms":"_5D2KwOct","terms__h1":"_5D21QJ63","pl-10":"_5D2itNuh","mb-10":"_5D4K92bo","main-list":"_5D1I4GcM","upper":"_5D2OoRYn"};